import React, { Component } from 'react';
import { Toggle } from '@cimpress/react-components';

export default class ToggleDemo extends Component {
  state = {
    on: true,
    onSm: true,
    disabled: false,
  };

  toggle = () => {
    this.setState(prevState => ({ on: !prevState.on }));
  };

  toggleSm = () => {
    this.setState(prevState => ({ onSm: !prevState.onSm }));
  };

  toggleDisabled = () => {
    this.setState(prevState => ({ disabled: !prevState.disabled }));
  };

  render() {
    return (
      <div className="row">
        <div className="col-md-4">
          <Toggle on={this.state.on} onClick={this.toggle} disabled={this.state.disabled} />
        </div>
        <div className="col-md-4">
          <Toggle on={this.state.onSm} onClick={this.toggleSm} size="sm" disabled={this.state.disabled} />
        </div>
        <div className="col-md-4">
          <button className="btn btn-default" onClick={this.toggleDisabled}>
            {this.state.disabled ? 'Enable' : 'Disable'}
          </button>
        </div>
      </div>
    );
  }
}
